import React, { useCallback, useEffect, useRef, useState } from 'react';
import myconfig from '../Config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext, useUserContext } from '../Components/StateContext/UserContext';
import { RouteComponentProps, withRouter, useParams, useHistory, useLocation } from 'react-router-dom';
import RestService from '../Services/RestService';
import OKomLoading from '../Components/OsloKommuneUI/OKomLoading';
import { jwtDecode } from 'jwt-decode';
import PinField from "react-pin-field";
import cn from "classnames";

const formatPinDigit = (k: string): string => (/^\d$/.test(k) ? k : '');

// Hardcoded Vipps merchant-verification account: logs in with email + password
// (no email pin) so the Vipps team can verify the site during onboarding.
const VIPPS_EMAIL = "gressquel@outlook.com";

const LoginView: React.FC<RouteComponentProps> = (props) => {
  const { depId, classId, week } = useParams<{ depId: string; classId: string; week: string }>();
  const { user, userToken, setUserInfo, setDepartmentInfo, setToken } = useUserContext();
  const history = useHistory();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [userEmail, setUserEmail] = useState<string>("");
  const [showPinCodeForm, setShowPinCodeForm] = useState<boolean>(false);
  const [pinCompleted, setPinCompleted] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState<boolean>(false);
  const [userPassword, setUserPassword] = useState<string>("");

  // Already-authenticated visitors land here too (e.g. via a bookmark) — show a short notice
  // instead of the login form.
  const isLoggedIn = !!userToken || !!user?.Id;

  const handleLogout = () => {
    setDepartmentInfo(null);
    setUserInfo(null);
    setToken(null);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailFromQuery = params.get('email');
    if (emailFromQuery) {
      setUserEmail(emailFromQuery);
      setShowPinCodeForm(true);
    }
  }, [location.search]);

  useEffect(() => {

  }, [depId, classId, week]);


  const handleLogin = async () => {
    try {
      setIsLoading(true);
      const response = await RestService.get<Api.LoginResponse>('/api/login/testlogin');
      if (response.Success) {
        setToken(response.Token);
        const response_myinfo = await RestService.get<Api.User>(`/api/user/getuser/${jwtDecode(response.Token)["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]}`);
        setUserInfo(response_myinfo);
        const response_department = await RestService.get<Api.Department>(`/api/department/GetDepartment?id=${response_myinfo.DepartmentId}`);
        setDepartmentInfo(response_department);
        history.push('/');
      } else {
        toast.error(`Noe gikk galt: ${response.Message}`);
      }
    } catch (error) {
      toast.error(`Noe gikk galt: ${error}`);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleLoginUser = async () => {
    // Vipps merchant-verification account logs in with a password, not an email pin.
    if (userEmail.trim().toLowerCase() === VIPPS_EMAIL) {
      setShowPasswordForm(true);
      return;
    }
    try {
      setIsLoading(true);
      const response = await RestService.get<Api.LoginResponse>(`/api/login/sendpin?email=${encodeURIComponent(userEmail)}`);
      if (response.Success) {
        setShowPinCodeForm(true);
        if(response.Message != null){
          toast.success(response.Message);
        }
      } else {
        toast.error(`Noe gikk galt: ${response.Message}`);
      }
    } catch (error) {
      toast.error(`Noe gikk galt: ${error}`);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  const handlePinCode = async (pin: string) => {
    try {
      setIsLoading(true);
      const response = await RestService.get<Api.LoginResponse>(`/api/login/login?email=${encodeURIComponent(userEmail)}&pinCode=${pin}`);
      if (response.Success) {
        setToken(response.Token);
        const response_myinfo = await RestService.get<Api.User>(`/api/user/getuser/${jwtDecode(response.Token)["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]}`);
        setUserInfo(response_myinfo);
        const response_department = await RestService.get<Api.Department>(`/api/department/GetDepartment?id=${response_myinfo.DepartmentId}`);
        setDepartmentInfo(response_department);
        history.push('/');
      } else {
        setPinCompleted(false);
        toast.error(`${response.Message}`);
      }
    } catch (error) {
      toast.error(`Noe gikk galt: ${error}`);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  const handlePasswordLogin = async () => {
    try {
      setIsLoading(true);
      const response = await RestService.get<Api.LoginResponse>(`/api/login/vippslogin?email=${encodeURIComponent(userEmail)}&password=${encodeURIComponent(userPassword)}`);
      if (response.Success) {
        setToken(response.Token);
        const response_myinfo = await RestService.get<Api.User>(`/api/user/getuser/${jwtDecode(response.Token)["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]}`);
        setUserInfo(response_myinfo);
        const response_department = await RestService.get<Api.Department>(`/api/department/GetDepartment?id=${response_myinfo.DepartmentId}`);
        setDepartmentInfo(response_department);
        history.push('/');
      } else {
        toast.error(`${response.Message}`);
      }
    } catch (error) {
      toast.error(`Noe gikk galt: ${error}`);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  const onEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserEmail(event.target.value);

  };

  
  // Stable callback so PinField v4's effect doesn't fire repeatedly per render.
  const handlePinCodeRef = useRef(handlePinCode);
  handlePinCodeRef.current = handlePinCode;

  const handlePinComplete = useCallback((pin: string) => {
    setPinCompleted(true);
    handlePinCodeRef.current(pin);
  }, []);


  return (
    <>
      {isLoading === true && <OKomLoading text='Logger inn, vennligst vent...'></OKomLoading>}
      <div className="ods-margin-top-25 ods-grid ods-grid--gap ods-grid--center">

        <div className="ods-grid__column--12 ods-grid__column--start-3-breakpoint-medium ods-grid__column--end-10-breakpoint-medium">
          {!isLoggedIn && showPinCodeForm && (
            <aside className="ods-infobox ods-infobox--yellow ods-margin-bottom-3">
              <h2 className="ods-infobox__heading">Finner du ikke pin-koden?</h2>
              <div className="ods-content">
                <p>Gmail, Outlook, Hotmail — sjekk om e-posten har havnet i Junk Mail / Søppelpost.</p>
              </div>
            </aside>
          )}
          <div className="ods-status-card">
            <div className="ods-status-card__content">

              {isLoggedIn &&
                <>
                  <h3 className="ods-status-card__heading ods-text--align-center">Du er allerede logget inn som:</h3>
                  <p className="ods-text--align-center" style={{ margin: '0.5rem 0 0', fontWeight: 700 }}>{user?.Firstname} {user?.Lastname}</p>
                  <p className="ods-text--align-center" style={{ margin: 0 }}>{user?.Email}</p>
                  <div className="ods-status-card__actions ods-margin-top-11">
                    <div className="ods-text--align-center" style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                      <button className="ods-button" onClick={() => history.push('/')}>Gå til portalen</button>
                      <button className="ods-button ods-button--outline" onClick={handleLogout}>Logg ut</button>
                    </div>
                  </div>
                </>
              }

              {!isLoggedIn && showPinCodeForm &&
                <>
                   <span>Vi har sendt deg en pin kode på e-post, det kan ta opptil 2 minutter. Hvis det ikke har kommet fram, prøv på nytt</span>
                  <div className="pin-field-container">

                  <PinField
                    length={5}
                    inputMode="numeric"
                    className={cn("pin-field", { complete: pinCompleted })}
                    onComplete={handlePinComplete}
                    format={formatPinDigit}
                    autoFocus
                    disabled={pinCompleted}
                    autoComplete="one-time-code"
                  />
                  </div>
                <div className="ods-status-card__actions">
                  <div className="ods-text--align-center">
                    <button disabled={isLoading} className="ods-button ods-button--outline" onClick={(e) => setShowPinCodeForm(false)}><span className="ods-button__icon ods-button__icon--right ods-icon--chevron-thin-left"></span> Logg inn på nytt</button></div>
                </div>
              </>
              }
              {!isLoggedIn && showPasswordForm &&
                <>
                  <h3 className="ods-status-card__heading">INNLOGGING</h3>
                  <label className="ods-input__label ods-margin-top-11">
                    Passord
                  <input value={userPassword}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handlePasswordLogin();
                      }
                    }}
                    onChange={(e) => setUserPassword(e.target.value)}
                    className="ods-input__input"
                    type="password"
                    autoComplete="current-password"
                    autoFocus />
                  </label>
                  <div className="ods-status-card__actions">
                    <div className="ods-text--align-center">
                      <button disabled={isLoading} className="ods-button" onClick={handlePasswordLogin}>Logg inn</button></div>
                  </div>
                  <div className="ods-status-card__actions">
                    <div className="ods-text--align-center">
                      <button disabled={isLoading} className="ods-button ods-button--outline" onClick={() => { setShowPasswordForm(false); setUserPassword(""); }}><span className="ods-button__icon ods-button__icon--right ods-icon--chevron-thin-left"></span> Logg inn på nytt</button></div>
                  </div>
                </>
              }
              {!isLoggedIn && !showPinCodeForm && !showPasswordForm &&
                <>
                  <h3 className="ods-status-card__heading">INNLOGGING</h3>
                  <label className="ods-input__label ods-margin-top-11">
                    E-postadresse
                  <input value={userEmail}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleLoginUser();
                      }
                    }}
                    onChange={(e) => onEmailChange(e)}
                    className="ods-input__input"
                    type="email"
                    autoComplete="email" />
                  </label>
                  <div className="ods-status-card__actions">
                    <div className="ods-text--align-center">
                      <button disabled={isLoading} className="ods-button ods-button" onClick={handleLoginUser}>Logg inn</button></div>
                  </div>
                  <div className="ods-margin-top-11 ods-text--align-center">
                    <a href="/register" className="o-kom-link">Har du ikke konto? Registrer deg</a>
                  </div>
                </>
              }
            </div>
          </div>
        </div>



      </div>
    </>
  );
}

export default withRouter(LoginView);
